import { RootDomain } from 'model/root.model';
import { defaultsDeep } from 'libs/defaults-deep';

export type BaseUrls = {
	apiBaseUrl: string;
}

const defaultBaseUrls: BaseUrls = {
	apiBaseUrl: 'https://api.hive.id',
};

export const baseUrls$ = RootDomain.store<BaseUrls>(defaultsDeep({
	apiBaseUrl: process.env.API_BASE_URL,
}, defaultBaseUrls));
